(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-blocos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lp-hero-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-lp-hero-thumb');
        document.querySelectorAll('[data-lp-hero-thumb]').forEach(function (t) { t.classList.remove('active'); });
        document.querySelectorAll('[data-lp-hero-media]').forEach(function (m) { m.classList.remove('active'); });
        thumb.classList.add('active');
        var targetMedia = document.querySelector('[data-lp-hero-media="' + id + '"]');
        if (targetMedia) {
          targetMedia.classList.add('active');
          var mainBox = document.querySelector('.lp-hero-media-main');
          var isVideo = targetMedia.getAttribute('data-lp-media-type') === 'video';
          if (mainBox) mainBox.classList.toggle('is-video', isVideo);
        }
      });
    });

    document.querySelectorAll('[data-lp-video-embed]').forEach(function (media) {
      var hasAudio = media.hasAttribute('data-lp-video-audio');

      media.addEventListener('click', function () {
        var existingVideo = media.querySelector('.lp-video-el');

        if (existingVideo) {
          if (existingVideo.paused) { existingVideo.play(); } else { existingVideo.pause(); }
          return;
        }

        var template = media.querySelector('[data-lp-video-template]');
        if (!template) return;
        var videoNode = template.content.firstElementChild.cloneNode(true);
        media.innerHTML = '';
        media.appendChild(videoNode);
        videoNode.muted = !hasAudio;
        videoNode.play().catch(function () {
          videoNode.muted = true;
          videoNode.play();
        });

        if (hasAudio) {
          var muteBtn = document.createElement('button');
          muteBtn.type = 'button';
          muteBtn.className = 'lp-video-mute';
          muteBtn.setAttribute('aria-label', 'Ativar/desativar som');
          muteBtn.textContent = videoNode.muted ? '🔇' : '🔊';
          muteBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            videoNode.muted = !videoNode.muted;
            muteBtn.textContent = videoNode.muted ? '🔇' : '🔊';
          });
          media.appendChild(muteBtn);
        }
      });
    });

    document.querySelectorAll('[data-lp-copy-coupon]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-lp-copy-coupon');
        var codeSpan = btn.querySelector('.lp-affiliate-coupon-code');
        var originalText = codeSpan.textContent;

        function showCopied() {
          btn.classList.add('copied');
          codeSpan.textContent = 'Copiado!';
          setTimeout(function () {
            codeSpan.textContent = originalText;
            btn.classList.remove('copied');
          }, 2000);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(showCopied).catch(function () {
            fallbackCopy(code);
            showCopied();
          });
        } else {
          fallbackCopy(code);
          showCopied();
        }

        function fallbackCopy(text) {
          var textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(textarea);
        }
      });
    });

    document.querySelectorAll('.lp-photo-carousel').forEach(function (carousel) {
      var slides = carousel.querySelectorAll('.lp-photo-slide');
      var dots = carousel.querySelectorAll('.lp-photo-dot');
      var index = 0;
      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('active', idx === index); });
        dots.forEach(function (d, idx) { d.classList.toggle('active', idx === index); });
      }
      var prevBtn = carousel.querySelector('.lp-photo-prev');
      var nextBtn = carousel.querySelector('.lp-photo-next');
      if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { show(idx); }); });
    });

    document.querySelectorAll('.lp-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-lp-tab');
        document.querySelectorAll('.lp-tab').forEach(function (t) { t.classList.remove('active'); });
        document.querySelectorAll('.lp-gallery-panel').forEach(function (p) { p.classList.remove('active'); });
        tab.classList.add('active');
        var panel = document.querySelector('.lp-gallery-panel[data-lp-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });

    document.querySelectorAll('.lp-faq-item').forEach(function (item) {
      item.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        document.querySelectorAll('.lp-faq-item').forEach(function (i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });

    var hero = document.querySelector('.lp-hero');
    var sticky = document.getElementById('lp-sticky-atc');
    if (hero && sticky) {
      var observer = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      observer.observe(hero);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-conversao"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.currentScript ? document.currentScript.closest('.pc-root') : document.querySelector('.pc-root');
    if (!root) return;

    var variantsDataEl = root.querySelector('#pc-variants-data');
    var variants = [];
    try { variants = JSON.parse(variantsDataEl.textContent); } catch (e) { variants = []; }

    var selected = {};
    root.querySelectorAll('.pc-option').forEach(function (opt) {
      var pos = opt.getAttribute('data-pc-option-position');
      var active = opt.querySelector('.pc-pill.active');
      if (active) selected[pos] = active.getAttribute('data-pc-option-value');
    });

    function findVariant() {
      var positions = Object.keys(selected).sort(function (a, b) { return a - b; });
      return variants.find(function (v) {
        return positions.every(function (pos) {
          return v.options[pos - 1] === selected[pos];
        });
      });
    }

    function updateAvailability() {
      root.querySelectorAll('.pc-option').forEach(function (opt) {
        var pos = opt.getAttribute('data-pc-option-position');
        opt.querySelectorAll('.pc-pill').forEach(function (pill) {
          var value = pill.getAttribute('data-pc-option-value');
          var testSelection = Object.assign({}, selected);
          testSelection[pos] = value;
          var positions = Object.keys(testSelection).sort(function (a, b) { return a - b; });
          var match = variants.find(function (v) {
            return positions.every(function (p) { return v.options[p - 1] === testSelection[p]; });
          });
          pill.disabled = !!match && !match.available;
        });
      });
    }

    function applyVariant(v) {
      if (!v) return;
      var idInput = root.querySelector('#pc-variant-id');
      if (idInput) idInput.value = v.id;

      var pixEl = root.querySelector('#pc-price-pix');
      var fullEl = root.querySelector('#pc-price-full');
      var parcelValueEl = root.querySelector('#pc-price-parcel-value');
      var stickyPrice = root.querySelector('#pc-sticky-price');
      var finalCtaPrice = root.querySelector('#pc-final-cta-price');
      if (pixEl) pixEl.textContent = v.pix;
      if (fullEl) fullEl.textContent = v.price;
      if (parcelValueEl) parcelValueEl.textContent = v.installment;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (finalCtaPrice) finalCtaPrice.textContent = v.price;

      var addBtn = root.querySelector('#pc-add-btn');
      var addBtnText = root.querySelector('#pc-add-btn-text');
      var finalCtaBtn = root.querySelector('#pc-final-cta-add');
      if (addBtn) addBtn.disabled = !v.available;
      if (finalCtaBtn) finalCtaBtn.disabled = !v.available;
      if (addBtnText) addBtnText.textContent = v.available ? 'Adicionar ao carrinho' : 'Esgotado';

      if (v.image) {
        var mainImg = root.querySelector('.pc-slide.active img');
        if (mainImg) mainImg.src = v.image;
      }
    }

    root.querySelectorAll('.pc-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        var pos = pill.getAttribute('data-pc-option-position');
        var value = pill.getAttribute('data-pc-option-value');
        selected[pos] = value;

        var group = pill.closest('.pc-option');
        group.querySelectorAll('.pc-pill').forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
        var label = group.querySelector('[data-pc-option-value]');
        if (label) label.textContent = value;

        updateAvailability();
        applyVariant(findVariant());
      });
    });

    // Galeria
    var slides = root.querySelectorAll('.pc-slide');
    var thumbs = root.querySelectorAll('.pc-thumb');
    var counter = root.querySelector('#pc-counter-current');
    var galleryMain = root.querySelector('#pc-gallery-main');
    var slideIndex = 0;
    function showSlide(i) {
      slideIndex = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        var isActive = idx === slideIndex;
        s.classList.toggle('active', isActive);
        if (!isActive) {
          var vid = s.querySelector('video');
          if (vid) vid.pause();
          var wrap = s.querySelector('[data-pc-video]');
          if (wrap) wrap.classList.remove('is-playing');
        }
      });
      thumbs.forEach(function (t, idx) { t.classList.toggle('active', idx === slideIndex); });
      if (counter) counter.textContent = slideIndex + 1;
      if (galleryMain) {
        var activeSlide = slides[slideIndex];
        galleryMain.classList.toggle('pc-gallery-main--video', !!(activeSlide && activeSlide.classList.contains('pc-slide-video')));
      }
    }
    var prevBtn = root.querySelector('.pc-nav-prev');
    var nextBtn = root.querySelector('.pc-nav-next');
    if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(slideIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(slideIndex + 1); });
    thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { showSlide(idx); }); });

    // Quantidade
    var qtyInput = root.querySelector('#pc-qty-input');
    var qtyMinus = root.querySelector('[data-pc-qty-minus]');
    var qtyPlus = root.querySelector('[data-pc-qty-plus]');
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });

    // Acordeão
    root.querySelectorAll('.pc-accordion-head').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.pc-accordion-item');
        var isOpen = item.classList.contains('open');
        item.classList.toggle('open', !isOpen);
        head.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    // Sticky ATC
    var stickyBar = root.querySelector('#pc-sticky-atc');
    var stickyAddBtn = root.querySelector('#pc-sticky-add');
    var mainAddBtn = root.querySelector('#pc-add-btn');
    var anchor = root.querySelector('.pc-form');
    if (stickyBar && anchor) {
      var observer = new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      observer.observe(anchor);
    }
    if (stickyAddBtn && mainAddBtn) {
      stickyAddBtn.addEventListener('click', function () { mainAddBtn.click(); });
    }

    var finalCtaAddBtn = root.querySelector('#pc-final-cta-add');
    if (finalCtaAddBtn && mainAddBtn) {
      finalCtaAddBtn.addEventListener('click', function () { mainAddBtn.click(); });
    }

    // Vídeos — clicar no vídeo dá play/pause; afiliados têm botão de mutar/desmutar
    root.querySelectorAll('[data-pc-video]').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      if (!video) return;

      wrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-pc-mute]')) return;
        if (video.paused) {
          video.play();
          wrap.classList.add('is-playing');
        } else {
          video.pause();
          wrap.classList.remove('is-playing');
        }
      });

      video.addEventListener('ended', function () {
        wrap.classList.remove('is-playing');
      });

      var muteBtn = wrap.querySelector('[data-pc-mute]');
      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          video.muted = !video.muted;
          muteBtn.textContent = video.muted ? '🔇' : '🔊';
        });
      }
    });

    // Cupom de parceiros — copiar para a área de transferência
    root.querySelectorAll('.pc-coupon-btn').forEach(function (btn) {
      var labelEl = btn.querySelector('.pc-coupon-label');
      var originalLabel = labelEl ? labelEl.textContent : '';
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-pc-coupon');
        if (!code) return;

        function showCopied() {
          if (labelEl) labelEl.textContent = 'Copiado!';
          setTimeout(function () { if (labelEl) labelEl.textContent = originalLabel; }, 1800);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(showCopied).catch(function () {
            fallbackCopy(code, showCopied);
          });
        } else {
          fallbackCopy(code, showCopied);
        }
      });
    });

    function fallbackCopy(text, cb) {
      var tmp = document.createElement('textarea');
      tmp.value = text;
      tmp.style.position = 'fixed';
      tmp.style.opacity = '0';
      document.body.appendChild(tmp);
      tmp.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(tmp);
      if (cb) cb();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitrine-produtos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Countdown de urgência
    document.querySelectorAll('[data-vp-countdown]').forEach(function (el) {
      var hours = parseFloat(el.getAttribute('data-hours')) || 24;
      var end = Date.now() + hours * 60 * 60 * 1000;
      var hEl = el.querySelector('[data-vp-h]');
      var mEl = el.querySelector('[data-vp-m]');
      var sEl = el.querySelector('[data-vp-s]');
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
        if (diff > 0) requestAnimationFrame(function () { setTimeout(tick, 1000); });
      }
      tick();
    });

    // Vídeos de afiliados: play inicia mutado; botão dedicado ativa/desativa áudio
    document.querySelectorAll('[data-vp-affiliate-media]').forEach(function (media) {
      var playBtn = media.querySelector('[data-vp-affiliate-play]');
      var muteBtn = media.querySelector('[data-vp-affiliate-mute]');
      var template = media.querySelector('[data-vp-affiliate-video-template]');
      var videoNode = null;

      if (playBtn) {
        playBtn.addEventListener('click', function () {
          if (!template || videoNode) return;
          videoNode = template.content.firstElementChild.cloneNode(true);
          var poster = media.querySelector('[data-vp-affiliate-poster]');
          if (poster) poster.remove();
          playBtn.remove();
          media.insertBefore(videoNode, muteBtn || null);
          videoNode.muted = true;
          videoNode.play().catch(function () {});
          if (muteBtn) muteBtn.hidden = false;
        });
      }

      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!videoNode) return;
          videoNode.muted = !videoNode.muted;
          muteBtn.textContent = videoNode.muted ? '🔇' : '🔊';
          muteBtn.setAttribute('aria-label', videoNode.muted ? 'Ativar áudio' : 'Desativar áudio');
        });
      }
    });

    // Cupom de afiliado: copiar para a área de transferência
    document.querySelectorAll('[data-vp-copy-coupon]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-coupon');
        var label = btn.querySelector('[data-vp-copy-label]');
        function markCopied() {
          btn.classList.add('is-copied');
          if (label) label.textContent = 'copiado!';
          setTimeout(function () {
            btn.classList.remove('is-copied');
            if (label) label.textContent = 'copiar';
          }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(markCopied).catch(function () {
            markCopied();
          });
        } else {
          var temp = document.createElement('textarea');
          temp.value = code;
          document.body.appendChild(temp);
          temp.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(temp);
          markCopied();
        }
      });
    });

    // Filtro por categoria
    var filters = document.querySelectorAll('[data-vp-filter]');
    var cards = document.querySelectorAll('.vp-card[data-vp-category]');
    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filters.forEach(function (f) { f.classList.remove('active'); });
        btn.classList.add('active');
        var target = btn.getAttribute('data-vp-filter');
        cards.forEach(function (card) {
          var show = target === 'all' || card.getAttribute('data-vp-category') === target;
          card.hidden = !show;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
